import { FormPath } from '@formily/react';
/**
 * .d 和 a.b.c 组合，就是a.b.d
 * ..d 和 a.b.c 组合，就是a.d
 * @param path 可以是相对路径的path
 * @param contextPath 完整的上下文path
 * @returns 计算出的path
 */

export const calPath = (path, contextPath) => {
  if (!path.startsWith('.')) {
    return path;
  }

  let dotCount = Array.from(path).findIndex(v => v !== '.');
  dotCount = dotCount < 0 ? path.length : dotCount;
  return [...contextPath.split('.').slice(0, -dotCount), ...path.substring(dotCount).split('.')].filter(v => Boolean(v)).join('.');
};
/**
 * .d a.1.d a.*.c =>  a.1.c
 * @param path 相对路径
 * @param contextPath 完整的上下文path
 * @param fieldPath
 */

export const calFieldPath = (path, contextPath, fieldPath) => {
  let count = 0; // ...cpuPlatform  rule.0.cpuPlatform => count是12

  while (count <= contextPath.length) {
    const c = contextPath[contextPath.length - count - 1];

    if (c === path[path.length - count - 1]) {
      count++;
      continue;
    } else {
      break;
    }
  }

  const result = fieldPath.split('');

  for (let i = 0; i < contextPath.length - count; i++) {
    if (result[i] === '*') {
      result[i] = contextPath[i];
    }
  }

  return result.join('');
};
/**
 * 带相对路径计算的 concat
 * @param pre
 * @param path
 * @returns
 */

export const pathConcat = (pre, path) => {
  if (typeof path === 'string' && path.startsWith('.')) {
    return FormPath.parse(calPath(path, pre.toString()));
  }

  return pre.concat(path !== null && path !== void 0 ? path : '');
};
//# sourceMappingURL=es/utils/rPath.js.map